import React from 'react';
import {Tab, Nav} from 'react-bootstrap';
import styled from 'styled-components';

const TabNav = styled(Nav)`
  .nav-link {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #777;

    :hover {
      color: #000000;
    }
    &.active {
      color: #000000 !important;
      border-top-width: 2px;
      border-color: #ccc #ccc #fff !important;
    }
  }
`;

const TabContent = styled(Tab.Content)`
  border: 1px solid #cccccc;
  padding: 10px;
  background-color: #fff;
`;

const Tabs = ({
  id = 'react-tabs',
  defaultTab,
  tabs,
  tabPaneMinHeight = 'auto',
  contentOverflow = 'inherit',
}) => {
  const [tabKey, setTabKey] = React.useState(defaultTab);

  return (
    <Tab.Container
      id={id}
      defaultActiveKey={tabKey}
      onSelect={(activeKey) => setTabKey(activeKey)}
    >
      <TabNav variant="tabs" className="">
        {tabs.map((item, index) => (
          <Nav.Item
            key={`tab-item-${id}-${item.tabKey}`}
            style={index === 0 ? {marginLeft: '15px'} : {}}
          >
            <Nav.Link eventKey={item.tabKey}>{item.tabLabel}</Nav.Link>
          </Nav.Item>
        ))}
      </TabNav>
      <TabContent>
        {tabs.map((item) => (
          <Tab.Pane
            key={`tab-pane-${id}-${item.tabKey}`}
            eventKey={item.tabKey}
            style={{
              minHeight: tabPaneMinHeight,
              overflow: contentOverflow,
              paddingLeft: '7.5px',
              paddingRight: '7.5px',
            }}
          >
            {typeof item.content === 'function'
              ? item.content(item.tabKey === tabKey)
              : item.content}
          </Tab.Pane>
        ))}
      </TabContent>
    </Tab.Container>
  );
};

export default Tabs;
